var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-login" },
    [
      _vm.bookingState.selectedProfessional &&
      _vm.$route.path === "/booking/choose-cleaner"
        ? [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-12 text-center" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(_vm.$t("message.login.please_login_to_continue"))
                  )
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.displayBenefits
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("message.login.benefits.title")))
              ]),
              _vm._v(" "),
              _c("hr")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "button-large button-block button-login -indigo",
              on: {
                click: function($event) {
                  return _vm.preLogin("facebook")
                }
              }
            },
            [
              _c("i", { staticClass: "fab fa-facebook-f" }),
              _vm._v("   "),
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.login.login_with_facebook")))
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "button-large button-block button-login -red",
              on: {
                click: function($event) {
                  return _vm.preLogin("googleplus")
                }
              }
            },
            [
              _c("i", { staticClass: "fab fa-google" }),
              _vm._v("   "),
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.login.login_with_google")))
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "button-large button-block button-login btn-dark",
              on: {
                click: function($event) {
                  return _vm.preLogin("apple")
                }
              }
            },
            [
              _c("i", { staticClass: "fab fa-apple fa-lg" }),
              _vm._v("   "),
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.login.login_with_apple")))
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "background my-3" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("message.login.or")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 text-left" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userEmail,
                  expression: "userEmail"
                }
              ],
              staticClass: "form-control input-lg",
              class: { "form-alert": _vm.errorEmail },
              attrs: {
                type: "email",
                placeholder: _vm.$t("message.login.email")
              },
              domProps: { value: _vm.userEmail },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.userEmail = $event.target.value
                  },
                  function($event) {
                    return _vm.updateFormData("email", $event)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _vm.errorEmail
              ? _c("div", { staticClass: "form-alert-text -status-alert" }, [
                  _vm._v(_vm._s(_vm.errorEmailText))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userPassword,
                  expression: "userPassword"
                }
              ],
              staticClass: "form-control input-lg",
              class: { "form-alert": _vm.errorPassword },
              attrs: {
                type: "password",
                maxlength: "20",
                placeholder: _vm.$t("message.login.password")
              },
              domProps: { value: _vm.userPassword },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.userPassword = $event.target.value
                  },
                  function($event) {
                    return _vm.updateFormData("password", $event)
                  }
                ],
                keyup: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.preLogin("email")
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.preLogin("email")
                  }
                ]
              }
            }),
            _vm._v(" "),
            _vm.errorPassword
              ? _c("div", { staticClass: "form-alert-text -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errorPasswordText) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "button",
              {
                staticClass: "button-large button-block -cyan",
                on: {
                  click: function($event) {
                    return _vm.preLogin("email")
                  }
                }
              },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.isLoggingIn
                        ? _vm.$t("message.button.loading")
                        : _vm.$t("message.button.login")
                    )
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.displayForm("reset-password")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("message.login.forgot_password")))]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("message.login.dont_have_account")) +
            "\n    "
        ),
        _c(
          "a",
          {
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.displayForm("register")
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("message.login.sign_up")))]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-663841b2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663841b2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/LoginForm.vue
// module id = 1391
// module chunks = 0